import {Link as RoutedLink} from 'react-router-dom';

import type {CoreEntityType} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';

import {getEntityIcon, getEntityLinkText, getFilterEntityLinksForUser} from './helpers';

interface Props {
    userId: string;
    entityType: CoreEntityType;
}

export function CreateInfoPopoverEntityLink(props: Props) {
    const Icon = getEntityIcon(props.entityType);
    const linkText = getEntityLinkText(props.entityType);
    const href = getFilterEntityLinksForUser(props.userId, props.entityType);

    return (
        <Stack spacing={4}>
            <Link
                // @ts-expect-error
                as={RoutedLink}
                variant='secondary'
                size='small'
                to={href}
            >
                <Stack isHorizontal={true} spacing={4}>
                    <Icon size={16} color={colors.grey} />
                    {linkText}
                </Stack>
            </Link>
        </Stack>
    );
}
